import React, { PureComponent } from "react";
import { Modal } from "react-bootstrap";
import { getRequest } from "../../api/ApiService";

const STUDENT_ROLE = 1;

class StudentCourseModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      course_name: props.currentCourse ? props.currentCourse.name : "",
      course_id: props.currentCourse ? props.currentCourse.id : 0,
      course_members: [],
      users: []
    };
  }

  componentWillMount() {
    this.fetchCourseMembers();
    this.fetchUsers();
  }

  componentWillReceiveProps(nextProps) {
    const course_id = nextProps.currentCourse ? nextProps.currentCourse.id : 0;
    const course_name = nextProps.currentCourse
      ? nextProps.currentCourse.name
      : "";

    if (this.state.course_id !== course_id) {
      this.setState(
        {
          course_name,
          course_id
        },
        () => {
          this.fetchCourseMembers();
        }
      );
    }
  }

  fetchCourseMembers = () => {
    const { course_id } = this.state;

    if (course_id > 0) {
      getRequest(
        `${process.env.REACT_APP_API_URL}courses/${course_id}/members/`
      )
        .then(res => {
          this.setState({
            course_members: res.body.filter(i => i.type === STUDENT_ROLE)
          });
        })
        .catch(err => {});
    } else {
      this.setState({
        course_members: []
      });
    }
  };

  fetchUsers = () => {
    getRequest(`${process.env.REACT_APP_API_URL}users/`)
      .then(res => {
        this.setState({
          users: res.body
        });
      })
      .catch(err => {});
  };

  getUserName = user_id => {
    const { users } = this.state;
    const user = users.find(i => i.id === user_id);

    return user ? user.username : "";
  };

  render() {
    const { show, onHide } = this.props;
    const { course_members } = this.state;

    return (
      <Modal show={show} onHide={onHide}>
        <Modal.Header>
          <h4 className="modal-title title-light-blue">Student List Popup</h4>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive">
            <table className="table">
              <tbody>
                {course_members.map((course_member, index) => (
                  <tr key={index} className="border-none instructor-modal-row">
                    <td>
                      {index + 1}. {this.getUserName(course_member.user)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default StudentCourseModal;



// WEBPACK FOOTER //
// ./src/instructor/components/student-course-modal.js